import {loadAnalytics} from '#/analytics/load-analytics';
import {initializeBraze} from '#/braze/initialize-braze';
import environment from '#/environment/environment';
import * as Sentry from '@sentry/react';
import {useEffect} from 'react';
import {createRoutesFromChildren, matchRoutes, useLocation, useNavigationType} from 'react-router';

export const loadTrackersAndAnalytics = () => {
  const LOAD_TRACKERS_AND_ANALYTICS = import.meta.env.PROD;
  if (LOAD_TRACKERS_AND_ANALYTICS) {
    if (environment.brazeApiKey) {
      initializeBraze();
    }

    if (environment.segmentIOApiKey) {
      loadAnalytics();
    }

    if (environment.sentryEnvironmentName) {
      Sentry.init({
        dsn: environment.sentryDsn,
        environment: environment.sentryEnvironmentName,
        integrations: [
          new Sentry.BrowserTracing({
            tracePropagationTargets: [environment.apiUrl],
            routingInstrumentation: Sentry.reactRouterV6Instrumentation(
              useEffect,
              useLocation,
              useNavigationType,
              createRoutesFromChildren,
              matchRoutes,
            ),
          }),
          new Sentry.Integrations.Breadcrumbs({
            console: false,
          }),
        ],
        tracesSampleRate: 0.5,
      });
    }
  }
};
